module.exports = __webpack_public_path__ + "img/1728348841351-Screenshot_8-10-2024_85319_www.instagram.com.jpeg.48856f61.webp";